import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

export function useUpdateFreight() {
  const [loading, setLoading] = useState(false);
  async function execute(
    freightId: string,
    body: {
      pickUpDate: string | null;
      pickUpTime?: string | null;
      deliveryLimitDate?: string | null;
      numberOfHelpers: string;
      freightStatus: string;
      freightType?: string;
      driverId?: string | null;
      vehicleId?: string | null;
    },
    callback?: () => void,
  ) {
    try {
      setLoading(true);
      const patchPayload: any = {
        pickUpDate: body.pickUpDate === null ? '' : body.pickUpDate,
        numberOfHelpers: Number(body.numberOfHelpers),
        freightStatus: body.freightStatus,
        freightType: body.freightType,
      };

      if (body.pickUpTime !== undefined && body.pickUpTime !== null) {
        patchPayload.pickUpTime = body.pickUpTime;
      }
      if (body.deliveryLimitDate !== undefined && body.deliveryLimitDate !== null) {
        patchPayload.deliveryLimitDate = body.deliveryLimitDate;
      }
      if (body.driverId !== undefined && body.driverId !== null) {
        patchPayload.driverId = body.driverId;
      }
      if (body.vehicleId !== undefined && body.vehicleId !== null) {
        patchPayload.vehicleId = body.vehicleId;
      }

      const response = await api.patch(`v1/backoffice/freights/${freightId}`, patchPayload);

      if (response.status === 200) {
        if (callback) callback();
      }
    } catch (error) {
      toast.error(ToastMessages.general.error.genericError);
    } finally {
      setLoading(false);
    }
  }
  return { execute, loading };
}
